import styled from 'styled-components';
import { devices } from '../../utilities/responsive';

export const Related = styled.div`
    display: flex;
    margin-bottom: 64px;

    @media ${devices.tabletPortrait} {
        flex-direction: column;
    }
    
    .related-article {
        max-width: calc(100% / 3);
        flex: 1;

        @media ${devices.tabletPortrait} {
            max-width: 100%;
            margin: 30px 0 !important;
            padding-bottom: 30px;
            border-bottom: 1px solid rgb(75, 79, 90);
        }

        &:not(:last-child) {
            margin-right: 50px;
        }

        .social-bar {
            justify-content: space-between;
        }

        .article__info {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: 300;
            color: var(--light-grey);
        }

        a {
            color: var(--white);

            p {
                color: var(--white);
                font-weight: 300;
            }

            &:hover {
                .title {
                    color: var(--primary-on-hover);
                }
            }
        }
    }
`;

export const RelatedTitle = styled.h6`
    padding-top: 10px;
    border-top: 1px solid #4B4F5A;
`